import type { ChartData, ChartOptions } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

import useColor from '@/hooks/domain/useColor';
import { CUSTOMER_QUERY_SENTIMENT } from '@/types/customerConst';

type Props = {
  current: number;
  total: number;
  sentiment: CUSTOMER_QUERY_SENTIMENT;
};

const defaultOptions: ChartOptions<'doughnut'> = {
  responsive: true,
  plugins: {
    tooltip: {
      enabled: false,
    },
    legend: {
      display: false,
    },
    datalabels: {
      display: false,
    },
  },
  cutout: '80%',
  circumference: 180,
  rotation: 270,
};

const SentimentChart = (props: Props) => {
  const color = useColor();
  const sentimentMap = {
    [CUSTOMER_QUERY_SENTIMENT.HAPPY]: {
      label: 'Happy',
      color: color.green500,
    },
    [CUSTOMER_QUERY_SENTIMENT.UNHAPPY]: {
      label: 'Unhappy',
      color: color.red600,
    },
  };

  const chartData: ChartData<'doughnut'> = {
    labels: [sentimentMap[props.sentiment].label],
    datasets: [
      {
        data: [props.current, props.total - props.current],
        backgroundColor: [sentimentMap[props.sentiment].color, color.gray300],
        borderColor: 'transparent',
        borderWidth: 2,
      },
    ],
  };

  return (
    <Doughnut
      data={chartData}
      options={defaultOptions}
      width="100%"
      height="100%"
    />
  );
};

export default SentimentChart;
